import { inject, Injectable } from '@angular/core';
import { FreightAvailableCommandService } from '@okcargo-apps/shared-infrastructure';
import {
  AcceptFreightAssignationFromMarketCommand,
  AddFreightCollaboratorInterestedCommand,
} from '@okcargo/command-processor';

@Injectable({
  providedIn: 'root',
})
export class FreightAvailableMutationsService {
  private readonly freightAvailableCommandService = inject(FreightAvailableCommandService);

  public async acceptFreightAssignationFromMarket(id: string): Promise<void> {
    this.freightAvailableCommandService
      .acceptFreightAssignationFromMarket({
        // assignationId: assignationId,
        parentAssignationId: null as unknown as string,
        freightId: id,
      } as AcceptFreightAssignationFromMarketCommand)
      .then(
        (): void => {
          // TODO review this
        },
        async (error: any): Promise<void> => {
          // TODO implement this
          console.warn(error);
        },
      );
  }

  public async showInterestOnFreight(_id: string): Promise<void> {
    this.freightAvailableCommandService
      .addFreightCollaboratorInterested({
        id: _id,
        comments: '',
      } as AddFreightCollaboratorInterestedCommand)
      .then(
        () => {
          // TODO review this
        },
        async (error: any) => {
          // TODO implement this
          console.warn(error);
        },
      );
  }
}
